<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />

            <div :style="{ display: mode === 'search' ? 'block' : 'none' }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.CODEMNG.CODE.TYPE')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="codeType">
                                        <option value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                        <option value="D">{{$t('FIELD.CODEMNG.DYNAMIC')}}</option>
                                        <option value="S">{{$t('FIELD.CODEMNG.STATIC')}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.CODEMNG.CASH.STATUS')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="cacheStatus">
                                        <option value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                        <option value="N">{{$t('FIELD.GLOBAL.NO')}}</option>
                                        <option value="Y">{{$t('FIELD.GLOBAL.YES')}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.CODEMNG.CODE.NAME')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" placeholder="Input code name" v-model="codeName" @keyup.enter.stop="search(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.CODEMNG.CODE.ID')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" placeholder="Input code" v-model="codeId" @keyup.enter.stop="search(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="clickSearch(1)">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>

                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- left: total count -->
                    <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                    <!-- right: button area -->
                    <div class="btn_wrap">
                        <a href="JavaScript:" class="btn_gray" @click="clickCreate()" title>{{$t('BUTTON.GLOBAL.CREATE')}}</a>
                    </div>
                    <!-- Grid -->
                    <keep-alive>
                        <code-list-grid
                            :gridId="gridId"
                            :data="gridData"
                            :columns="columns"
                            :options="options"
                            :pageOptions="pageOptions"
                            :key="gridKey"
                            :click="contentClick"
                            :isTotalCount="false"
                            :menuMode="menuMode"
                        />
                    </keep-alive>
                </div>
            </div>
            <content-view v-if="mode == 'view'" :pCategoryId="categoryId"></content-view>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import SDLPagination from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import CodeListGrid from '~c/ToastGrid';
import CodeAdminView from './CodeAdminView';

// ToastGrid Code Type renderer
class CategoryType {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        if (resVal == 'S') resVal = 'Static';
        else if (resVal == 'D') resVal = 'Dynamic';
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'CodeAdminList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'code-list-grid': CodeListGrid,
        'content-view': CodeAdminView,
    },
    data() {
        return {
            isLoading: true,
            mode: 'search', // 'view'
            searchStatus: 'done', // 'loading', 'disabled'
            menuMode: 'CODE',
            condition: null,
            pageTitle: '',
            codeType: '',
            codeName: '',
            codeId: '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            gridKey: 0,
            cacheStatus: '',
            resultCount: 0,
            categoryId: '',
            gridId: 'codeAdminGrid',
//            options: {},
            gridData: [],
            searchFormData: {},
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.TYPE'),
                    name: 'CODETYPECODE',
                    width: 200,
                    align: 'center',
                    sortable: true,
                    renderer: { type: CategoryType },
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.ID'),
                    name: 'CODECATEGORYID',
                    width: 250,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.NAME'),
                    name: 'CODECATEGORYNAME',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USE.STATUS'),
                    name: 'STATUSCODE',
                    align: 'center',
                    width: 130,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CASH.STATUS'),
                    name: 'CACHEYN',
                    align: 'center',
                    width: 130,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'),
                    name: 'REGDATE',
                    align: 'center',
                    width: 200,
                    sortable: true,
                },
            ],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    computed: {},
    methods: {
        async search(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            this.searchStatus = 'loading';
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/code/codeAdminList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;
                    this.searchStatus = 'done';
                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        initLoad() {
            this.search(1);
        },
        // 그리드 row 클릭 시...
        clickCreate() {
            this.categoryId = null;
            this.mode = 'view';
        },
        // 그리드 row 클릭 시...
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            this.fetchContent(event.rowKey);
        },
        // 상세페이지로 이동
        fetchContent(rowIdx) {
            let item = this.gridData[rowIdx];
            SDLUtil.showLoadingBar(true);

            this.categoryId = item.CODECATEGORYID;
            this.mode = 'view';

            window.scrollTo(0, 0);
            SDLUtil.showLoadingBar(false);
        },
        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                codeTypeCode: this.codeType,
                cacheYn: this.cacheStatus,
                codeName: this.codeName,
                codeId: this.codeId
            };
            return params;
        },
        clickSearch() {
            this.search(1);
        }, // clickSearch
        goList(data) {
            this.search(this.currentPage);
            this.mode = 'search';
        }
    }, // methods
    created() {
        EventBus.$on('goCodeList', this.goList);
    },
    mounted() {
        this.initLoad();
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goCodeList');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/code/CodeAdminList.vue